import {FieldConfig} from '../../dynamic-field/field.config';

interface OptionValue {
    optionLabel: string;
    optionValue: string;
}

export interface OptionFieldConfig extends FieldConfig<string> {
    options?: OptionValue[];
    orientation: string;
}
